export const requestStatus = {
    OK: 200,
    Created: 201,
    Accepted: 202,
    BadRequest: 400,
    Unauthorized: 401,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    RequestTimeout: 408,
    UnsupportedMediaType: 415,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
};

export const successStatus: number[] = [
    requestStatus.OK,
    requestStatus.Created,
    requestStatus.Accepted,
];
